import { useState, useEffect } from 'react';
import { isMobile, isLandscape, addOrientationListener } from '../utils/platform';

interface OrientationState {
  isLandscape: boolean;
  isMobile: boolean;
}

export const useOrientation = (): OrientationState => {
  const [isLandscapeState, setIsLandscape] = useState<boolean>(isLandscape());

  useEffect(() => {
    const cleanup = addOrientationListener(setIsLandscape);
    return cleanup;
  }, []);

  return { isLandscape: isLandscapeState, isMobile };
};
